<template>
    <div id="tabs-navigation" class="container px-0">
        <nav class="ob1-menu-page ob1-menu-page-fullscreen ob1-menu-page-icon h-auto">
            <ul class="nav ob1-nav-light">
                <li
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :data-test-id="'tab-' + index"
                    :class="tab.id"
                    class="nav-item"
                >
                    <button
                        class="nav-link"
                        :data-oevent-category="tab.tmsButton.category"
                        :data-oevent-action="tab.tmsButton.action"
                        :data-oevent-label="tab.tmsButton.label"
                        @click="changeSelectedTab(tab.id)"
                    >
                        <span
                            class="item-icon"
                            :class="tab.icon"
                            aria-hidden="true"
                        />{{ tab.label }}
                    </button>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>

export default {
    name: "OffersTabs",
    components: {
    },
    props: {
        tabs: {type: Array, required: true}
    },
    data() {
        return {
            hashTag: undefined,
        }
    },
    mounted() {
        window.addEventListener("hashchange", this.updateSelectedTabFromHash);
        this.updateSelectedTabFromHash();
    },
    beforeDestroy: function () {
        window.removeEventListener("hashchange", this.updateSelectedTabFromHash);
    },
    methods: {
        readHash() {
            const hash = window.location.hash;
            return hash.startsWith("#") ? hash.substring(1) : hash
        },
        updateSelectedTabFromHash() {
            const hash = this.readHash();
            if (hash !== this.hashTag) {
                if (hash === "") {
                    this.hashTag = "";
                }
                // si hashtag valide alors sélectionne onglet correspondant
                else if (Array.from(this.tabs.map(el => el.id)).includes(hash)) {
                    this.hashTag = hash;
                    Array.from(document.getElementsByClassName("nav-item")).forEach(
                        function (el) {
                            el.classList.remove('active');
                        }
                    );
                    document.querySelector("."+hash).classList.add('active');
                    this.$nextTick(() => this.scrollActiveTabIntoView(hash));
                }
                // sinon force affichage du premier onglet par défaut
                else {
                    this.changeSelectedTab(this.tabs[0].id);
                }
            }
        },
        changeSelectedTab(tabId) {
            if (!tabId) return;

            const currentHash = this.readHash();
            if (currentHash !== tabId) {
                const newUrl = `${window.location.pathname}${window.location.search}#${tabId}`;
                window.history.pushState(window.history.state, "", newUrl);
                window.dispatchEvent(new HashChangeEvent("hashchange"));

                this.$emit('toggle-tab', { tab: tabId });
            }
        },
        scrollActiveTabIntoView(tabId) {
            const activeItem = this.$el.querySelector("." + tabId);
            if (activeItem) {
                activeItem.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
            }
        },
    }
}
</script>

<style scoped lang="scss">
// Force une largeur égale pour tous les onglets et empêche le multiligne
.ob1-nav-light > .nav-item {
  flex-basis: 0;

  .nav-link {
    white-space: nowrap;
  }
}

</style>
